import { useAppDispatch, useAppSelector } from "../../../../hooks";
import { useNavigate } from "react-router-dom";
import {
  getAiJobLogsAsync,
  selectAiJob,
  selectAiJobLoading,
  selectAiJobLogs,
  selectAiJobLogsLoading,
} from "../../../../store/ai/jobs/jobSlice";
import LogTerminal, {
  LogsTerminalLog,
  useLogTerminal,
} from "../../../general/LogTerminal";
import { useEffect, useMemo } from "react";

const AiJobLogsTab = () => {
  const job = useAppSelector(selectAiJob);
  const jobLoading = useAppSelector(selectAiJobLoading);

  const logs = useAppSelector(selectAiJobLogs);
  const logsLoading = useAppSelector(selectAiJobLogsLoading);

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { scrollToEnd } = useLogTerminal();

  useEffect(() => {
    if (job) dispatch(getAiJobLogsAsync({ id: job.id }));
  }, [dispatch, job]);

  // useEffect(() => {
  //   let interval: NodeJS.Timeout | null = null;

  //   if (job) {
  //     dispatch(
  //       getAiJobLogsAsync({
  //         id: job.id,
  //         withoutLoading: true,
  //       })
  //     );

  //     interval = setInterval(() => {
  //       dispatch(
  //         getAiJobLogsAsync({
  //           id: job.id,
  //           withoutLoading: true,
  //         })
  //       );
  //     }, 7000);
  //   }

  //   return () => {
  //     if (interval) {
  //       clearInterval(interval);
  //     }
  //   };
  // }, [dispatch, job]);

  const orderedLogs: LogsTerminalLog[] = useMemo(() => {
    return [
      ...logs.map((log) => ({ time: log.timestamp, content: log.content })),
    ];
  }, [logs]);

  useEffect(() => {
    scrollToEnd();
  }, [logsLoading, scrollToEnd]);

  return (
    <>
      <LogTerminal
        loading={logsLoading || jobLoading}
        logs={orderedLogs}
        serviceName={job?.spec.name}
        logRowClassName="!py-0.5 !leading-5"
      />
    </>
  );
};

export default AiJobLogsTab;
